export default `/* Ids Home Page Component */
.ids-home-page {
  position: relative;
  background-color: var(--ids-homepage-color-background-default);
}
.ids-home-page .widgets {
  position: absolute;
  left: 50%;
}
.ids-home-page ::slotted(ids-widget) {
  position: absolute;
  --ids-widget-height: calc(100% - 8px);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtaG9tZS1wYWdlIiwic291cmNlcyI6WyJpZHMtaG9tZS1wYWdlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUFDQTtFQUNFO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOztBQUdGO0VBQ0U7RUFFQSIsInNvdXJjZXNDb250ZW50IjpbIi8qIElkcyBIb21lIFBhZ2UgQ29tcG9uZW50ICovXG4uaWRzLWhvbWUtcGFnZSB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0taWRzLWhvbWVwYWdlLWNvbG9yLWJhY2tncm91bmQtZGVmYXVsdCk7XG5cbiAgLndpZGdldHMge1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICBsZWZ0OiA1MCU7XG4gIH1cblxuICA6OnNsb3R0ZWQoaWRzLXdpZGdldCkge1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcblxuICAgIC0taWRzLXdpZGdldC1oZWlnaHQ6IGNhbGMoMTAwJSAtIDhweCk7XG4gIH1cbn1cbiJdfQ== */`;
